/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddBoxIcon from "@material-ui/icons/AddBox";
import DropDownSelector from "./DropDownSelector";
import "./RoleManager.css";
import MultipleDropDown from "./MultipleDropDown";

const RoleManager = ({ rolesFromParent, setRolesFromParent, possibleRoles, creators }) => {
  const [sortedCreators, setSortedCreators] = useState(creators);

  // sort creators for the dropdown in SingleRole (quality of life)
  useEffect(() => {
    let temp = creators.slice();

    if (temp.length > 1) {
      temp.sort((a, b) => {
        if (a.name < b.name) return -1;
        else if (a.name > b.name) return 1;
        else return 0;
      });
    }
    setSortedCreators(temp);
  }, [creators]);

  //ADD NEW ROLE AND APPEND EXISTING TO ROLES
  const addNewRole = () => {
    let temp = rolesFromParent.slice();
    temp.push({ creator_id: "", title: "" });
    setRolesFromParent(temp);
  };

  //DELETE ROLE GIVEN INDEX
  const deleteRole = (i) => {
    let temp = rolesFromParent.slice();
    temp.splice(i, 1);
    setRolesFromParent(temp);
  };

  //UPDATE SINGLE ROLE IN ARRAY
  const setRoleInArray = (data, i) => {
    let temp = rolesFromParent.slice();
    temp[i] = data;
    setRolesFromParent(temp);
  };

  return (
    <>
      {rolesFromParent &&
        rolesFromParent.map((role, i) => {
          return (
            <div className="add-book-form__field" key={i}>
              <SingleRole
                creators={sortedCreators}
                role={role}
                setRole={(data) => {
                  setRoleInArray(data, i);
                }}
                possibleRoles={possibleRoles}
                key={i}
                handleDelete={() => deleteRole(i)}
              />
            </div>
          );
        })}
      <div className="add-icon">
        <IconButton aria-label="delete" size="medium" color="primary" onClick={addNewRole}>
          <AddBoxIcon fontSize="inherit" />
        </IconButton>
      </div>
    </>
  );
};

export default RoleManager;

const SingleRole = ({ role, setRole, possibleRoles, creators, handleDelete }) => {
  // ROLE OBJECT
  // CREATOR DATA
  const [selectedCreator, setSelectedCreator] = useState(
    role.creator_id || ""
  );
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedRolesForDropdown, setSelectedRolesForDropdown] = useState([]);

  // Keep local creator selection in sync when parent role changes
  useEffect(() => {
    setSelectedCreator(role.creator_id || "");
  }, [role.creator_id]);

  // turning the string of role titles into selections for the dropdown
  useEffect(() => {
    if (role && role.title) {
      let tempRoleList = [];
      let temp = role.title.split(",");

      temp.forEach((t) => {
        possibleRoles.forEach((p) => {
          if (t.toLowerCase() === p.name.toLowerCase()) tempRoleList.push(p);
        });
      });
      setSelectedRolesForDropdown(tempRoleList);
    }
  }, [role]);

  // sets the Role state as a string of types "separated,by,commas"
  // Use selectedCreator (not stale role) so choosing roles after a creator
  // does not overwrite creator_id back to the empty sentinel.
  useEffect(() => {
    // don't run this useEffect on initial load
    if (selectedRoles.length > 0) {
      let temp = `${selectedRoles.map((r) => `${r.name}`)}`;
      const creatorId =
        selectedCreator === "" || selectedCreator == null
          ? ""
          : parseInt(selectedCreator, 10);
      setRole({
        ...role,
        creator_id: Number.isNaN(creatorId) ? selectedCreator : creatorId,
        title: temp,
      });
    }
  }, [selectedRoles]);

  // function for creator dropdown
  const handleCreatorDrop = (creator) => {
    const creatorId = creator === "" ? "" : parseInt(creator, 10);
    setSelectedCreator(creatorId);
    setRole({
      ...role,
      creator_id: Number.isNaN(creatorId) ? creator : creatorId,
    });
  };

  return (
    <div>
      {role && (
        <div className="role-editor">
          <div className="role-editor__role">
            <MultipleDropDown
              data={possibleRoles}
              placeholder="Role(s)"
              setValue={(e) => {
                setSelectedRoles(e);
              }}
              value={selectedRolesForDropdown}
            />
          </div>
          :{"   "}
          <div className="role-editor__creator" style={{ marginLeft: "10px" }}>
            <DropDownSelector
              data={creators}
              className="form-control"
              value={selectedCreator}
              placeholder="Creator"
              onChange={handleCreatorDrop}
            />
          </div>
          <div className="role-editor__delete-icon">
            <IconButton aria-label="delete" size="medium" color="secondary" onClick={() => handleDelete()}>
              <DeleteIcon fontSize="inherit" />
            </IconButton>
          </div>
        </div>
      )}
    </div>
  );
};
